import { render, staticRenderFns } from "./ArchiveChangeInfo.vue?vue&type=template&id=fac3a72c&scoped=true"
import script from "./ArchiveChangeInfo.vue?vue&type=script&lang=js"
export * from "./ArchiveChangeInfo.vue?vue&type=script&lang=js"
import style0 from "./ArchiveChangeInfo.vue?vue&type=style&index=0&id=fac3a72c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac3a72c",
  null
  
)

export default component.exports